import { HALALBOX_INDIA_CC_NUMBER } from '../../util/constantServices';

export const WHATSAPP_INTRO_MSG = 'Hi there, please help me with my query.';

export const WHATSAPP_HELP_TEXT = 'Contact us for more queries';

export const CC_WHATSAPP_LINK = `https://wa.me/91${HALALBOX_INDIA_CC_NUMBER}?text=${encodeURI(
  WHATSAPP_INTRO_MSG
)}`;
